@if (activeMenu() !== null) {
    <div
        class="pointer-events-auto hidden w-full px-4 sm:px-6 md:block lg:px-8"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
    >
        <div class="mx-auto max-w-[96rem] pt-2 pb-6">
            <!-- 1. DEALS MEGA MENU (Spacious max-w-6xl with Clean UI) -->
            @if (activeMenu() === 'deals') {
                <div
                    class="mega-menu-card mx-auto max-w-6xl overflow-hidden rounded-2xl border border-slate-200/90 bg-white/98 shadow-2xl ring-1 shadow-slate-900/10 ring-slate-900/5 backdrop-blur-md"
                >
                    <div class="p-8">
                        <div
                            class="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-10"
                        >
                            @for (
                                group of dealGroups();
                                track group.groupTitle
                            ) {
                                <div class="space-y-3">
                                    <div
                                        class="flex items-center justify-between px-3"
                                    >
                                        <h3
                                            class="text-[11px] font-bold tracking-wider text-slate-400 uppercase"
                                        >
                                            {{ group.groupTitle }}
                                        </h3>
                                    </div>
                                    <div class="space-y-1">
                                        @for (
                                            item of group.items;
                                            track item.title
                                        ) {
                                            <a
                                                [routerLink]="[
                                                    '/category',
                                                    item.slug,
                                                ]"
                                                (click)="onClose()"
                                                class="group flex items-start gap-3.5 rounded-xl border border-transparent p-3 text-left transition-all duration-200 hover:translate-x-0.5 hover:border-slate-200/60 hover:bg-slate-50/90"
                                            >
                                                <div
                                                    class="group-hover:text-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-200/70 bg-gradient-to-b from-slate-50 to-slate-100/80 text-slate-600 shadow-2xs transition-all duration-200 group-hover:scale-105 group-hover:border-blue-200/80 group-hover:from-blue-50 group-hover:to-blue-100/60"
                                                >
                                                    <img
                                                        [src]="item.image"
                                                        [alt]="item.title"
                                                        class="h-5 w-5 object-contain transition-transform duration-200 group-hover:scale-110"
                                                    />
                                                </div>
                                                <div class="min-w-0 flex-1">
                                                    <p
                                                        class="group-hover:text-primary truncate text-sm font-semibold text-slate-800 transition-colors duration-150"
                                                    >
                                                        {{ item.title }}
                                                    </p>
                                                    <p
                                                        class="mt-0.5 line-clamp-1 text-xs leading-relaxed text-slate-500"
                                                    >
                                                        {{ item.description }}
                                                    </p>
                                                </div>
                                                <ng-icon
                                                    name="lucideChevronRight"
                                                    class="text-primary mt-1 h-4 w-4 shrink-0 -translate-x-1 opacity-0 transition-all duration-200 group-hover:translate-x-0 group-hover:opacity-100"
                                                />
                                            </a>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Spacious Clean Footer Strip with Subtle Status Indicator -->
                    <div
                        class="flex items-center justify-between border-t border-slate-100 bg-slate-50/80 px-8 py-3.5 text-xs text-slate-500"
                    >
                        <span class="flex items-center gap-2">
                            <span
                                class="flex h-2 w-2 rounded-full bg-emerald-500"
                            ></span>
                            <span
                                >Discover exclusive verified deals, special
                                offers and discounts across all categories</span
                            >
                        </span>
                        <a
                            routerLink="/category/groceries"
                            (click)="onClose()"
                            class="group text-primary hover:text-primary/80 inline-flex items-center gap-1.5 font-semibold transition-colors"
                        >
                            <span>View All Categories</span>
                            <ng-icon
                                name="lucideArrowRight"
                                class="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5"
                            />
                        </a>
                    </div>
                </div>
            }

            <!-- 2. FUN MEGA MENU (Spacious max-w-3xl Clean 2-Card Layout) -->
            @if (activeMenu() === 'fun') {
                <div
                    class="mega-menu-card mx-auto max-w-3xl overflow-hidden rounded-2xl border border-slate-200/90 bg-white/98 p-7 shadow-2xl ring-1 shadow-slate-900/10 ring-slate-900/5 backdrop-blur-md"
                >
                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
                        <!-- Raffle Activity Card -->
                        <div
                            class="group relative flex flex-col justify-between rounded-2xl border border-amber-200/60 bg-gradient-to-b from-amber-50/40 via-white to-amber-50/20 p-6 transition-all duration-200 hover:border-amber-300/80 hover:shadow-md hover:shadow-amber-500/5"
                        >
                            <div>
                                <div
                                    class="mb-3.5 flex items-center justify-between"
                                >
                                    <div
                                        class="flex h-11 w-11 items-center justify-center rounded-xl border border-amber-200/80 bg-amber-100/70 text-amber-700 shadow-2xs transition-transform group-hover:scale-105"
                                    >
                                        <ng-icon
                                            name="lucideTrophy"
                                            class="h-5 w-5"
                                        />
                                    </div>
                                    <span
                                        class="inline-flex items-center gap-1 rounded-full bg-amber-100/80 px-2.5 py-1 text-[10px] font-bold tracking-wider text-amber-800 uppercase"
                                    >
                                        <span
                                            class="h-1.5 w-1.5 animate-pulse rounded-full bg-amber-500"
                                        ></span>
                                        Win Prizes
                                    </span>
                                </div>
                                <h3
                                    class="text-base font-bold text-slate-900 transition-colors group-hover:text-amber-900"
                                >
                                    Raffle & Lucky Draws
                                </h3>
                                <p
                                    class="mt-1 text-xs leading-relaxed text-slate-600"
                                >
                                    Enter exciting draws, win premium gifts, and
                                    track current winning tickets.
                                </p>
                            </div>

                            <div
                                class="mt-6 flex items-center justify-between gap-3 border-t border-amber-100 pt-4"
                            >
                                <a
                                    routerLink="/client/raffle"
                                    (click)="onClose()"
                                    class="group/btn bg-primary hover:bg-primary/90 hover:shadow-primary/20 active:bg-primary/80 inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-semibold text-white shadow-xs transition-all hover:shadow-md"
                                >
                                    <span>Enter Raffles</span>
                                    <ng-icon
                                        name="lucideArrowRight"
                                        class="h-3.5 w-3.5 transition-transform group-hover/btn:translate-x-0.5"
                                    />
                                </a>
                                <a
                                    routerLink="/client/raffle/winners"
                                    (click)="onClose()"
                                    class="text-xs font-semibold text-slate-600 transition-colors hover:text-slate-900"
                                >
                                    Winners Podium
                                </a>
                            </div>
                        </div>

                        <!-- Quiz Activity Card -->
                        <div
                            class="group relative flex flex-col justify-between rounded-2xl border border-indigo-200/60 bg-gradient-to-b from-indigo-50/40 via-white to-indigo-50/20 p-6 transition-all duration-200 hover:border-indigo-300/80 hover:shadow-md hover:shadow-indigo-500/5"
                        >
                            <div>
                                <div
                                    class="mb-3.5 flex items-center justify-between"
                                >
                                    <div
                                        class="flex h-11 w-11 items-center justify-center rounded-xl border border-indigo-200/80 bg-indigo-100/70 text-indigo-700 shadow-2xs transition-transform group-hover:scale-105"
                                    >
                                        <ng-icon
                                            name="lucideHelpCircle"
                                            class="h-5 w-5"
                                        />
                                    </div>
                                    <span
                                        class="inline-flex items-center gap-1 rounded-full bg-indigo-100/80 px-2.5 py-1 text-[10px] font-bold tracking-wider text-indigo-800 uppercase"
                                    >
                                        Daily Challenge
                                    </span>
                                </div>
                                <h3
                                    class="text-base font-bold text-slate-900 transition-colors group-hover:text-indigo-900"
                                >
                                    Trivia & Quizzes
                                </h3>
                                <p
                                    class="mt-1 text-xs leading-relaxed text-slate-600"
                                >
                                    Challenge your knowledge with quick daily
                                    quizzes, earn bonus coins and rank up.
                                </p>
                            </div>

                            <div
                                class="mt-6 flex items-center justify-between gap-3 border-t border-indigo-100 pt-4"
                            >
                                <a
                                    routerLink="/quiz"
                                    (click)="onClose()"
                                    class="group/btn bg-primary hover:bg-primary/90 hover:shadow-primary/20 active:bg-primary/80 inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-xs font-semibold text-white shadow-xs transition-all hover:shadow-md"
                                >
                                    <span>Play Daily Quizzes</span>
                                    <ng-icon
                                        name="lucideArrowRight"
                                        class="h-3.5 w-3.5 transition-transform group-hover/btn:translate-x-0.5"
                                    />
                                </a>
                                <a
                                    routerLink="/quiz"
                                    (click)="onClose()"
                                    class="text-xs font-semibold text-slate-600 transition-colors hover:text-slate-900"
                                >
                                    Rules & Rewards
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}
